module.exports = __webpack_public_path__ + "img/section1SwiperTab4.4aaf0c4a.png";